<template>
  <div>

    <v-form>
      <v-card color="grey lighten-5">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Banka Pos Giriş Ekranı</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn v-if="taksitbtn" @click="Guncelle()" flat> <span class="hidden-sm-and-down"> Güncelle </span>
                <v-icon right dark>create</v-icon>
              </v-btn>
              <v-btn v-if="kaydetbtn" @click="Kaydet()" flat> <span class="hidden-sm-and-down"> Kaydet </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="bankapossil()" v-if="taksitbtn">
                    <v-list-tile-title>Sil</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="TaksitEkle()" v-if="taksitbtn">
                    <v-list-tile-title>Taksit Girişi</v-list-tile-title>
                  </v-list-tile>
                  <a target="_self" v-bind:href="'#/parametreler/genel/bankapos'">
                    <v-list-tile>
                      <v-list-tile-title>İptal</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>



            </v-toolbar>
          </v-flex>




          <v-layout row wrap>

            <v-flex pa-1 xs12 sm6 md3>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>

                    <v-layout justify-space-between column>
                      <v-flex xs12 sm12 md12>

                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium "> Seçenekler</span>
                          </v-card-title>
                        </v-card>

                      </v-flex>

                      <v-text-field :color="color" :disabled="diskode =='1'" hide-details="" label="Banka Pos Kodu"
                        v-model="BankaPos.PosCode" :error-messages="errors.collect('poscode')" v-validate="'required|max:4'"
                        data-vv-name="poscode" required>
                      </v-text-field>



                      <v-text-field :color="color" hide-details="" label="Açıklama" v-model="BankaPos.Explaniton"
                        :error-messages="errors.collect('posaciklama')" v-validate="'required'" data-vv-name="posaciklama"
                        required>
                      </v-text-field>


                      <v-select :items="BankList" hide-details="" :color="color" v-bind="BankList" item-text="BankaAdi"
                        item-value="BankaKod" v-model="BankaPos.Parameters.Banka.BankaKod" label="Banka Kodu"></v-select>



                      <v-autocomplete label="Pos Cari Kodu Seçiniz" :color="color" append-icon="search" :loading="loading"
                        :items="statecari" item-text="text" hide-details cache-items="" item-value="id"
                        :search-input.sync="search" v-model="BankaPos.Parameters.PosMuhKodu"></v-autocomplete>



                      <v-autocomplete label="Puan Cari Kodu Seçiniz" hide-details :color="color" append-icon="search"
                        :loading="loading" :items="statecari2" item-text="text" cache-items="" item-value="id"
                        :search-input.sync="search1" v-model="BankaPos.Parameters.PuanCariKodu"></v-autocomplete>



                      <v-menu :close-on-content-click="true" v-model="menu" transition="scale-transition" offset-y
                        full-width :nudge-right="40" min-width="290px">
                        <v-text-field :color="color" hide-details="" slot="activator" label="Söz.Baş.Tar." v-model="dateFormatted"
                          append-icon="event" v-on:change="onChange" mask="##.##.####" @blur="date = parseDate(dateFormatted)"></v-text-field>
                        <v-date-picker locale="tr" v-model="date" @input="dateFormatted = formatDate($event)" no-title
                          scrollable actions>
                          <v-spacer></v-spacer>
                        </v-date-picker>
                      </v-menu>


                      <v-menu :close-on-content-click="true" v-model="menu2" transition="scale-transition" offset-y
                        full-width :nudge-right="40" min-width="290px">
                        <v-text-field slot="activator" hide-details="" label="Söz.Bit.Tar." v-model="dateFormatted2"
                          append-icon="event" :color="color" v-on:change="onChange2" mask="##.##.####" @blur="date2 = parseDate2(dateFormatted2)"></v-text-field>
                        <v-date-picker locale="tr" v-model="date2" @input="dateFormatted2 = formatDate2($event)"
                          no-title scrollable actions>
                          <v-spacer></v-spacer>
                        </v-date-picker>
                      </v-menu>


                      <v-text-field :color="color" hide-details="" label="Üyelik Ücreti" v-model="BankaPos.Parameters.UyelikTutar"></v-text-field>

                      <v-text-field mask="##.##" :color="color" label="Yüzde %" hide-details="" v-model="BankaPos.Parameters.UyelikOran"
                        v-validate="'min:4'" :error-messages="errors.collect('uyelikoran')" data-vv-name="uyelikoran"></v-text-field>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


            <v-flex pa-1 xs12 sm6 md3>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-flex xs12 sm12 md12>
                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium "> Muhasebe Kodu</span>
                          </v-card-title>
                        </v-card>
                      </v-flex>

                      <v-text-field :color="color" hide-details="" label="(F) Kartlı Alacaklı Muh. Kodu" v-model="BankaPos.MuhasebeKodlar.MuhasebeKodu"></v-text-field>

                      <v-text-field :color="color" hide-details="" label="(C) Kartlı Alacaklı Muh. Kodu" v-model="BankaPos.MuhasebeKodlar.CMuhasebeKodu"></v-text-field>



                      <v-text-field :color="color" hide-details="" label="(F) Kartlı Dış Akt. Cari Kodu" v-model="BankaPos.MuhasebeKodlar.FDisAktarimCariKodu">
                      </v-text-field>


                      <v-text-field :color="color" hide-details="" label="(F) Kartlı Dış Akt. Muh. Kodu" v-model="BankaPos.MuhasebeKodlar.FDisAktarimMuhKodu"></v-text-field>

                      <v-text-field :color="color" hide-details="" label="(C) Kartlı Dış Akt. Cari Kodu" v-model="BankaPos.MuhasebeKodlar.CDisAktarimCariKodu"></v-text-field>


                      <v-text-field :color="color" hide-details="" label="(C) Kartlı Dış Akt. Muh. Kodu" v-model="BankaPos.MuhasebeKodlar.CDisAktarimMuhKodu"></v-text-field>

                      <v-text-field :color="color" hide-details="" label="Servis Muhasabe Kodu" v-model="BankaPos.MuhasebeKodlar.ServisMuhasebeKodu"></v-text-field>


                      <v-text-field :color="color" hide-details="" label="Servis Dış Akt. Cari Kodu" v-model="BankaPos.MuhasebeKodlar.ServisDisAktarimCariKodu"></v-text-field>


                      <v-text-field :color="color" hide-details="" label="Servis Dış Akt. Muh. Kodu" v-model="BankaPos.MuhasebeKodlar.ServisDisAktarimMuhKodu"></v-text-field>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


            <v-flex pa-1 xs12 sm6 md3>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>

                    <v-layout justify-space-between column>

                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Kota Bilgileri</span>
                        </v-card-title>
                      </v-card>
                      <v-text-field :color="color" label="Kota" hide-details="" v-model="BankaPos.Parameters.Kota"></v-text-field>
                      <v-layout>

                        <v-text-field :color="color" hide-details="" label="Kota Ceza Ücreti" v-model="BankaPos.Parameters.KotaCezaTutar"></v-text-field>.
                        <v-text-field mask="##.##" :color="color" hide-details="" label="Yüzde %" v-model="BankaPos.Parameters.KotaCezaOran"></v-text-field>
                      </v-layout>


                      <v-text-field :color="color" hide-details="" label="Kota Gün" v-model="BankaPos.Parameters.KotaGun"></v-text-field>
                      <v-flex xs12 sm12 md12>
                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium "> Pos Bilgileri</span>
                          </v-card-title>
                        </v-card>

                      </v-flex>


                      <v-text-field hide-details="" :color="color" label="Terminal ID" v-model="BankaPos.Parameters.TerminalID"></v-text-field>


                      <v-text-field hide-details="" :color="color" label="İşyeri ID" v-model="BankaPos.Parameters.UyeIsYeriID"></v-text-field>

                      <v-text-field hide-details="" :color="color" label="Kullanıcı Adı" v-model="BankaPos.Parameters.UserName"></v-text-field>

                      <v-text-field hide-details="" :color="color" label="Şifre" v-model="BankaPos.Parameters.UserPass"></v-text-field>

                      <v-text-field hide-details="" :color="color" label="Store Key" v-model="BankaPos.Parameters.StoreKey"></v-text-field>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex pa-1 xs12 sm6 md3>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Vade Seçenekleri</span>
                        </v-card-title>
                      </v-card>
                      <v-radio-group v-model="BankaPos.Parameters.VadeTip" hide-details="" column>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-radio label="Ertesi Gün Vade Farkı" value="0"> </v-radio>
                          </v-flex>
                          <v-flex xs12 sm1 md1>
                            <v-card color="white">
                              <input width="20px" v-model="BankaPos.Parameters.VadeFarkSabit" type="text">
                            </v-card>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-radio label="Sabit Gün" value="1"></v-radio>
                          </v-flex>
                          <v-flex xs12 sm1 md1>
                            <v-card color="white">
                              <input width="20px" v-model="BankaPos.Parameters.VadeSabitGun" type="text">
                            </v-card>
                          </v-flex>
                        </v-layout>
                        <v-radio label="Her Taksit Ertesi Gün Vadesinde" value="2"></v-radio>
                      </v-radio-group>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Pos Tipi</span>
                        </v-card-title>
                      </v-card>

                      <v-radio-group hide-details="" v-model="BankaPos.Parameters.PosType" column>
                        <v-radio label="Sadece Normal" value="0"> </v-radio>
                        <v-radio label="Sadece 3D" value="1"></v-radio>
                        <v-radio label="3D ve Normal" value="2"></v-radio>
                      </v-radio-group>
                      <v-switch label="Pos Aktif" v-model="BankaPos.Parameters.Aktif" hide-details></v-switch>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


          </v-layout>

            <v-layout v-if="taksitbtn" row wrap>
              <v-flex xs12 sm12 md12>
                <v-layout justify-space-between column>

                   <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Taksit Listesi</span>
                        </v-card-title>
                      </v-card>

                  <div >
                    <div id="app">
                      <v-app id="inspire">
                        <v-card>
                          <v-card-title>
                            <v-spacer></v-spacer>
                            <v-text-field append-icon="search" label="Arama" single-line hide-details v-model="searcharama"></v-text-field>
                          </v-card-title>
                          <v-data-table :headers="headers" :rows-per-page-items=[50,100] :items="items11" :search="searcharama">
                            <template slot="items" slot-scope="props">
                              <tr @click="taksitgetir(props.item.TaksitID,props.item.PosKod)" item>
                                <td class="text-xs-left">{{ props.item.TaksitID }}</td>
                                <td class="text-xs-left">{{ props.item.PosKod }}</td>
                                <td class="text-xs-left">{{ props.item.TaksitAciklama }}</td>
                                <td class="text-xs-left">{{ props.item.TaksitAdet }}</td>
                                <td class="text-xs-left">{{ props.item.VadeFarkTutar }}</td>
                                <td class="text-xs-left">{{ props.item.VadeFarkYuzde }}</td>
                                <td class="text-xs-left">{{ props.item.PuanTutar }}</td>
                                <td class="text-xs-left">{{ props.item.PuanYuzde }}</td>
                              </tr>
                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                              "{{ searcharama }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı.
                            </v-alert>
                          </v-data-table>
                        </v-card>
                      </v-app>
                    </div>
                  </div>
                </v-layout>
              </v-flex>
            </v-layout>
        </v-layout>
      </v-card>
    </v-form>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>


    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card color="grey lighten-5">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>




            <v-layout row wrap>
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                <v-layout justify-space-between column>
                  <div v-show="codegorunum === true ">
                    <v-text-field label="Banka Pos Kodu" :color="color" v-model="Taksit.PosCode" :error-messages="errors.collect('bankapos')"
                      data-vv-name="bankapos" disabled>
                    </v-text-field>
                  </div>
                  <v-text-field :color="color" :error-messages="errors.collect('taksitaciklama')" data-vv-name="taksitaciklama"
                    v-validate="'required'" label="Açıklama" v-model="Taksit.InsExplanation" required> </v-text-field>
                  <v-text-field :color="color" mask="##" label="Taksit  Sayısı" v-model="Taksit.InsNumber">
                  </v-text-field>
                  <v-layout>
                    <v-text-field :color="color" label="Vade Farkı" v-model="Taksit.ExpiryDifAmount"></v-text-field>
                    <v-text-field :color="color" label="Yüzde%" v-model="Taksit.ExpiryDifPercent"></v-text-field>
                  </v-layout>
                  <v-layout>
                    <v-text-field :color="color" label="Puan" v-model="Taksit.PointAmount"> </v-text-field>
                    <v-text-field :color="color" label="Yüzde%" v-model="Taksit.PointPercent"> </v-text-field>
                  </v-layout>
                  <v-layout>
                    <v-text-field :color="color" label="Vade Farkı Satış" v-model="Taksit.ExpiryDifAmountSales">
                    </v-text-field>
                    <v-text-field :color="color" label=" Yüzde%" v-model="Taksit.ExpiryDifPercentSales"> </v-text-field>
                  </v-layout>
                  <v-layout>
                    <v-text-field :color="color" label="Puan Satış" v-model="Taksit.PointAmountSales"> </v-text-field>
                    <v-text-field :color="color" label="Yüzde%" v-model="Taksit.PointPercentSales"> </v-text-field>
                  </v-layout>
                </v-layout>
</v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

            </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" flat @click="vazgec()">Vazgeç</v-btn>
          <div v-show="m === true">
            <v-btn color="blue darken-1" flat @click="taksitsil()">Sil</v-btn>
            <v-btn color="blue darken-1" flat @click="TaksitGuncelle()">Güncelle</v-btn>
          </div>
          <div v-show="k === true">
            <v-btn id="bkaydet" color="blue darken-1" flat @click="Taksitkaydet()">Taksit Ekle</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import '../../../assets/css/custom.css'
  export default {

    props: {
      operation: ''
    },

    data() {
      return {
        headers: [{
            text: ' Taksit ID',
            value: 'TaksitID'
          },
          {
            text: 'Pos Kod',
            value: 'PosKod'
          },
          {
            text: 'Açıklama',
            value: 'TaksitAciklama'
          },
          {
            text: 'Taksit Adet',
            value: 'TaksitAdet'
          },
          {
            text: 'Vade Farkı (Tutar)',
            value: 'VadeFarkTutar'
          },
          {
            text: 'Vade Farkı (Yüzde)',
            value: 'VadeFarkYuzde'
          },
          {
            text: 'Puan (Tutar)',
            value: 'PuanTutar'
          },
          {
            text: 'Puan (Yüzde)',
            value: 'PuanYuzde'
          }
        ],
        drawer: null,
        color: 'orange darken-4',
        switch1: true,
        baslik: '',
        items11: [],
        dialog: false,
        dialog_baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        loading: false,
        search: '',
        searcharama: '',
        search1: '',
        karsicari: true,
        codegorunum: true,
        diskode: '0',
        m: false,
        k: false,
        BankaPos: {
          BankaPosID: '',
          CompanyCode: '',
          PosCode: '',
          Explaniton: '',
          Codes: '',
          Amount: '',
          MuhasebeKodlar: {
            MuhasebeKodu: '',
            CMuhasebeKodu: '',
            FDisAktarimCariKodu: '',
            FDisAktarimMuhKodu: '',
            CDisAktarimCariKodu: '',
            CDisAktarimMuhKodu: '',
            ServisMuhasebeKodu: '',
            ServisDisAktarimCariKodu: '',
            ServisDisAktarimMuhKodu: ''
          },
          Parameters: {
            Banka: {
              BankaKod: '',
            },
            ID: '',
            PosMuhKodu: '',
            PuanCariKodu: '',
            SozlesmeBaslangic: '',
            SozlesmeBitis: '',
            Aktif: '',
            VadeTip: '',
            UyelikTutar: '',
            UyelikOran: '',
            Kota: '',
            KotaGun: '',
            KotaCezaTutar: '',
            KotaCezaOran: '',
            VadeSabitGun: '0',
            VadeFarkSabit: '1',
            KotaKod: '',
            TerminalID: '',
            UyeIsYeriID: '',
            UserName: '',
            UserPass: '',
            PosType: '',
            StoreKey: ''
          },
        },
        Taksit: {
          InsID: '',
          CompanyCode: '',
          PosCode: '',
          InsExplanation: '',
          InsNumber: '',
          ExpiryDifPercent: '',
          ExpiryDifAmount: '',
          PointPercent: '',
          PointAmount: '',
          ExpiryDifPercentSales: '',
          ExpiryDifAmountSales: '',
          PointPercentSales: '',
          PointAmountSales: ''
        },
        BankList: [],
        statecari: [],
        statecari2: [],
        taksitbtn: false,
        kaydetbtn: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        urlyedek: '',
        dictionary: {
          custom: {
            poscode: {
              required: () => 'Bu alan boş bırakılamaz',
              max: () => 'En fazla 4 karakterden oluşmalıdır'
            },
            uyelikoran: {
              min: () => 'lütfen Ör: 04.00 vs formatında doldurunuz'
            },
            posaciklama: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            taksitaciklama: {
              required: () => 'Bu alan boş bırakılamaz'
            },

          }
        }
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      formatDate(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      formatDate2(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {
          console.log('')
        } else if (n == -1 && m != 8) {
          this.dateFormatted = getDateNow1()
          this.date = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      parseDate2(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {
          console.log('')
        } else if (n == -1 && m != 8) {
          this.dateFormatted2 = getDateNow1()
          this.date2 = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      karsicariac: karsicariac,
      carigetir: carigetir,
      carigetir1: carigetir1,
      Kaydet: Kaydet,
      TaksitEkle: TaksitEkle,
      vazgec: vazgec,
      onChange: onChange,
      onChange2: onChange2,
      yuzdeyap: yuzdeyap,
      yuzdegoster: yuzdegoster,
      toDateformat: toDateformat,
      toDate: toDate,
      Guncelle: Guncelle,
      tarihkontrol: tarihkontrol,
      Taksitkaydet: Taksitkaydet,
      getir: getir,
      taksitgetir: taksitgetir,
      bankapossil: bankapossil,
      taksitsil: taksitsil,
      TaksitGuncelle: TaksitGuncelle
    },
    beforeMount: beforeMount,
    watch: {
      search(val) {
        val && this.carigetir(val)
      },
      search1(val2) {
        val2 && this.carigetir1(val2)
      }
    },
  }

  function bankapossil() {
    if (window.confirm('Banka Pos\'u silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));


      var params = {
        CompanyCode: credentials.SirketKodu,
        PosCode: this.BankaPos.PosCode
      }

      this.$http.post(auth.API_URL + 'api/BankPos/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.dialog = false
          this.text1 = response.body.ResponseMessage
          this.snackbar = true

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true

        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.body.Status
          this.snackbar = true
        }
      })
    }
  }

  function taksitsil() {
    if (window.confirm('Taksit \'i silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));



      var params = {
        PosCode: this.Taksit.PosCode,
        CompanyID: credentials.SirketKodu,
        insId: this.Taksit.InsID,
      }

      this.$http.post(auth.API_URL + 'api/BankPos/InsDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.dialog = false
          this.text1 = response.body.ResponseMessage
          this.snackbar = true

          var paramsn = {
            InsID: '',
            CompanyID: credentials.SirketKodu,
            PosCode: this.BankaPos.PosCode
          }
          this.$http.post(auth.API_URL + 'api/BankPos/InsList', paramsn, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items11 = response.body
          }, (response) => {
            if (response.Status === false) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            }
          })
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.body.Status
          this.snackbar = true
        }
      })
    }
  }



  function getir(v) {
    this.k = false
    this.m = true
    this.codegorunum = false
    this.dialog = true
    this.dialog_baslik = 'Taksit Güncelle/Sil'
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));



    var params = {
      CompanyCode: credentials.SirketKodu,
      PosCode: v
    }
    this.$http.post(auth.API_URL + 'api/doctype/Get', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.Evrak.DocTypeCode = response.body[0].Evrakkod
      this.Evrak.DocTypeName = response.body[0].Aciklama
      this.select = response.body[0].BA.trim()
      this.Evrak.AccountDC = response.body[0].Cari
    })
  }

  function vazgec() {
    this.dialog = false

  }

  function TaksitEkle() {

    this.dialog = true
    this.k = true
    this.dialog_baslik = 'Taksit Ekle'
    this.Taksit = {}
    this.Taksit.PosCode = this.BankaPos.PosCode

  }

  function Guncelle() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));




    if (this.BankaPos.Parameters.Aktif == true) {
      this.BankaPos.Parameters.Aktif = '1'
    } else {
      this.BankaPos.Parameters.Aktif = '0'
    }

    if (this.BankaPos.Parameters.VadeTip == '0') {
      this.BankaPos.Parameters.VadeSabitGun = null

    } else if (this.BankaPos.Parameters.VadeTip == '1') {
      this.BankaPos.Parameters.VadeFarkSabit = null

    } else {
      this.BankaPos.Parameters.VadeSabitGun = null
      this.BankaPos.Parameters.VadeFarkSabit = null
    }

    if (this.BankaPos.Parameters.UyelikOran.length > 0 && this.BankaPos.Parameters.UyelikOran != '0' && this.BankaPos.Parameters
      .UyelikOran != '00' && this.BankaPos.Parameters.UyelikOran != '000' && this.BankaPos.Parameters.UyelikOran !=
      '0000') {
      var a = yuzdeyap(this.BankaPos.Parameters.UyelikOran)
      this.BankaPos.Parameters.UyelikOran = a
    }

    if (this.BankaPos.Parameters.KotaCezaOran.length > 0) {
      var b = yuzdeyap(this.BankaPos.Parameters.KotaCezaOran)
      this.BankaPos.Parameters.KotaCezaOran = b
    }

    this.BankaPos.Parameters.SozlesmeBaslangic = this.date
    this.BankaPos.Parameters.SozlesmeBitis = this.date2

    var params = {
      CompanyCode: credentials.SirketKodu,

      BankPosID: this.BankaPos.BankaPosID,

      PosCode: this.BankaPos.PosCode,

      Explaniton: this.BankaPos.Explaniton,

      Codes: this.BankaPos.MuhasebeKodlar,

      Parameters: this.BankaPos.Parameters
    }


    this.$http.post(auth.API_URL + 'api/BankPos/Update', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status === true) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      } else {
        this.text1 = response.body.ResponseMessage

        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }


  function TaksitGuncelle() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));



    var params = {
      PosCode: this.Taksit.PosCode,
      CompanyCode: credentials.SirketKodu,
      InsID: this.Taksit.InsID,
      InsExplanation: this.Taksit.InsExplanation,
      InsNumber: this.Taksit.InsNumber,
      ExpiryDifPercent: this.Taksit.ExpiryDifPercent,
      ExpiryDifAmount: this.Taksit.ExpiryDifAmount,
      PointPercent: this.Taksit.PointPercent,
      PointAmount: this.Taksit.PointAmount,
      ExpiryDifAmountSales: this.Taksit.ExpiryDifAmountSales,
      ExpiryDifPercentSales: this.Taksit.ExpiryDifPercentSales,
      PointPercentSales: this.Taksit.PointPercentSales,
      PointAmountSales: this.Taksit.PointAmountSales,
    }
    this.$http.post(auth.API_URL + 'api/BankPos/InsUpdate', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status === true) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.dialog = false

        var params1 = {
          CompanyID: credentials.SirketKodu,
          PosCode: this.Taksit.PosCode,
          InsID: ''
        }
        this.$http.post(auth.API_URL + 'api/BankPos/InsList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items11 = response.body

        }, (response) => {
          if (response.Status === false) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        })

      } else {
        this.text1 = response.body.ResponseMessage

        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }


  function Kaydet() {

    this.$validator.validateAll().then((result) => {

      if (result) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.BankaPos.Parameters.SozlesmeBaslangic = this.date
        this.BankaPos.Parameters.SozlesmeBitis = this.date2

        if (this.BankaPos.Parameters.Aktif == true) {
          this.BankaPos.Parameters.Aktif = '1'
        } else {
          this.BankaPos.Parameters.Aktif = '0'
        }

        if (this.BankaPos.Parameters.VadeTip == '0') {
          this.BankaPos.Parameters.VadeSabitGun = null

        } else if (this.BankaPos.Parameters.VadeTip == '1') {
          this.BankaPos.Parameters.VadeFarkSabit = null

        } else {
          this.BankaPos.Parameters.VadeSabitGun = null
          this.BankaPos.Parameters.VadeFarkSabit = null
        }

        if (this.BankaPos.Parameters.UyelikOran.length > 0) {
          var a = yuzdeyap(this.BankaPos.Parameters.UyelikOran)
          this.BankaPos.Parameters.UyelikOran = a
        }

        if (this.BankaPos.Parameters.KotaCezaOran.length > 0) {
          var b = yuzdeyap(this.BankaPos.Parameters.KotaCezaOran)
          this.BankaPos.Parameters.KotaCezaOran = b
        }


        var params = {
          CompanyCode: credentials.SirketKodu,
          PosCode: this.BankaPos.PosCode,
          Explaniton: this.BankaPos.Explaniton,
          Codes: this.BankaPos.MuhasebeKodlar,
          Parameters: this.BankaPos.Parameters,
        }

        this.$http.post(auth.API_URL + 'api/BankPos/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        }, (response) => {
          if (response.Status === false) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        })
      }
    })
  }

  function Taksitkaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    this.$validator.validateAll().then((result) => {

      if (result) {

        if (this.Taksit.ExpiryDifPercent != null) {
          var yuzde = yuzdeyap(this.Taksit.ExpiryDifPercent)
          this.Taksit.ExpiryDifPercent = yuzde
        }


        if (this.Taksit.ExpiryDifPercentSales != null) {
          var yuzde1 = yuzdeyap(this.Taksit.ExpiryDifPercentSales)
          this.Taksit.ExpiryDifPercentSales = yuzde1
        }


        var params = {
          CompanyCode: credentials.SirketKodu,
          PosCode: this.BankaPos.PosCode,
          InsExplanation: this.Taksit.InsExplanation,
          InsNumber: this.Taksit.InsNumber,
          ExpiryDifPercent: this.Taksit.ExpiryDifPercent,
          ExpiryDifAmount: this.Taksit.ExpiryDifAmount,
          PointPercent: this.Taksit.PointPercent,
          PointAmount: this.Taksit.PointAmount,
          ExpiryDifPercentSales: this.Taksit.ExpiryDifPercentSales,
          ExpiryDifAmountSales: this.Taksit.ExpiryDifAmountSales,
          PointPercentSales: this.Taksit.PointPercentSales,
          PointAmountSales: this.Taksit.PointAmountSales
        }

        this.$http.post(auth.API_URL + 'api/BankPos/InsAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.dialog = false

          var params1 = {
            CompanyID: credentials.SirketKodu,
            PosCode: this.Taksit.PosCode,
            InsID: null
          }

          this.$http.post(auth.API_URL + 'api/BankPos/InsList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items11 = response.body

          }, (response) => {
            if (response.Status === false) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            }
          })

        }, (response) => {
          if (response.Status === false) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        })
      }
    })
  }

  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)

      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesin
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date = b
          this.dateFormatted = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil

        } else {
          this.date = b
        }
      } else {
        this.dateFormatted = null

      }
    } else {
      this.dateFormatted = null
    }
  }

  function onChange2(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)
      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesi
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date2 = b
          this.dateFormatted2 = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil

        } else {
          this.date2 = b
        }
      } else {
        this.dateFormatted2 = null
      }
    } else {
      this.dateFormatted2 = null
    }
  }

  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }

  function karsicariac() {
    if (this.karsicari === false) {
      this.karsicari = true
    } else {
      this.karsicari = false
    }
  }

  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.Success = false
            this.Error = 'Service Unavailable'
          } else {
            this.Success = false
            this.Error = response.statusText
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function yuzdeyap(v) {

    var id = v.split('')
    if (v.length == 4) {
      return id[0] + id[1] + '.' + id[2] + id[3]
    } else if (v.length == 3) {
      return id[0] + id[1] + '.' + id[2] + '0'
    } else if (v.length == 2) {
      return id[0] + id[1] + '.' + '0' + '0'
    } else if (v.length == 1) {
      return id[0] + '0' + '.' + '0' + '0'
    } else {
      return null
    }
  }

  function yuzdegoster(v) {

    // tam değerli gelen
    var id = String(v).split('')
    var nokta = String(v).split('.')

    if (String(v).length == 5) {
      return id[0] + id[1] + '.' + id[3] + id[4]

      // tam sayı gelen
    } else if (String(v).length == 2) {
      return id[0] + id[1] + '.' + '0' + '0'
    }

    // 3 haneli gelen
    else if (String(v).length == 4) {
      if (String(nokta[0]).length == 2) {
        return nokta[0] + '.' + nokta[1] + '0'
      } else {
        return '0' + nokta[0] + '.' + nokta[1]
      }

      // 2 haneli gelen
    } else if (String(v).length == 3) {
      return '0' + nokta[0] + '.' + nokta[1] + '0'

    } else if (String(v).length == 1) {
      return '0' + id[0] + '.' + '0' + '0'
    } else {
      return null
    }
  }

  function carigetir1(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari2 = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.Success = false
            this.Error = 'Service Unavailable'
          } else {
            this.Success = false
            this.Error = response.statusText
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function toDate(dateStr) {
    var parts = dateStr[0].split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function tarihkontrol(v) {


    if (Object.prototype.toString.call(v) === "[object Date]") {
      return true
    } else {
      return false;
    }
  }

  function taksitgetir(y, z) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      InsID: y,
      CompanyID: credentials.SirketKodu,
      PosCode: z
    }

    this.$http.post(auth.API_URL + 'api/BankPos/InsList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.dialog = true
      this.dialog_baslik = 'Taksit Düzenle/Sil'
      this.m = true
      this.k = false

      this.Taksit.PosCode = response.body[0].PosKod
      this.Taksit.InsID = response.body[0].TaksitID
      this.Taksit.InsExplanation = response.body[0].TaksitAciklama
      this.Taksit.InsNumber = response.body[0].TaksitAdet
      this.Taksit.ExpiryDifPercent = response.body[0].VadeFarkYuzde
      this.Taksit.ExpiryDifAmount = response.body[0].VadeFarkTutar
      this.Taksit.PointPercent = response.body[0].PuanYuzde
      this.Taksit.PointAmount = response.body[0].PuanTutar
      this.Taksit.ExpiryDifAmountSales = response.body[0].VadeFarkTutarSatis
      this.Taksit.ExpiryDifPercentSales = response.body[0].VadeFarkYuzdeSatis
      this.Taksit.PointPercentSales = response.body[0].PuanYuzdeSatis
      this.Taksit.PointAmountSales = response.body[0].PuanTutarSatis


    }, (response) => {
      if (response.status === 0) {
        console.log('')
      } else {
        console.log('')
      }
    })

  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));



    this.urlyedek = '#' + String(this.$route.fullPath)
    if (this.$route.params.id == 'yeni') {
      this.taksitbtn = false
      this.kaydetbtn = true
    } else if (this.$route.params.id != 'yeni' && this.$route.params.id != null) {
      this.taksitbtn = true
      this.kaydetbtn = false
      var params1 = {
        CompanyCode: credentials.SirketKodu,
        PosCode: this.$route.params.id
      }

      this.$http.post(auth.API_URL + 'api/BankPos/Get', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.diskode = '1'
        this.items11 = response.body.Taksitler
        this.BankaPos.PosCode = response.body.PosKodu
        this.Taksit.PosCode = response.body.PosKodu
        this.BankaPos.BankaPosID = response.body.BankaPosID
        this.BankaPos.Explaniton = response.body.Aciklama
        this.BankaPos.MuhasebeKodlar = response.body.MuhasebeKodlar
        this.BankaPos.Parameters = response.body.Parametreler

        var bastarih = response.body.Parametreler.SozlesmeBaslangic.split("T")

        if (String(bastarih[0]) === '0001-01-01') {
          this.BankaPos.Parameters.SozlesmeBaslangic = null
        } else {
          this.BankaPos.Parameters.SozlesmeBaslangic = response.body.Parametreler.SozlesmeBaslangic
          var partsvalue = response.body.Parametreler.SozlesmeBaslangic.split("T")
          this.date = partsvalue[0]
          this.dateFormatted = toDateformat(this.date)
        }
        var bittarih = response.body.Parametreler.SozlesmeBitis.split("T")

        if (String(bittarih[0]) === '0001-01-01') {


          this.BankaPos.Parameters.SozlesmeBitis = null
        } else {

          this.BankaPos.Parameters.SozlesmeBitis = response.body.Parametreler.SozlesmeBitis
          var partsvalue1 = response.body.Parametreler.SozlesmeBitis.split("T")
          this.date2 = partsvalue1[0]
          this.dateFormatted2 = toDateformat(this.date2)

        }
        if (response.body.Parametreler.UyelikOran > 0) {
          var a = yuzdegoster(response.body.Parametreler.UyelikOran)
          response.body.Parametreler.UyelikOran = a
        } else {
          this.BankaPos.Parameters.UyelikOran = null
        }

        if (response.body.Parametreler.Aktif == 1) {
          this.BankaPos.Parameters.Aktif = true
        } else {
          this.BankaPos.Parameters.Aktif = false
        }

        this.BankaPos.Parameters.PosType = String(response.body.Parametreler.PosType)
        this.search = response.body.Parametreler.PosMuhKodu
        this.search1 = response.body.Parametreler.PuanCariKodu
      }, (response) => {
        if (response.status === 0) {
          console.log('ea')
        } else {
          console.log('ea')
        }
      })
    }
  }
</script>

<style>
</style>